// extracted by mini-css-extract-plugin
module.exports = {"container":"ffbf","video":"f3f5","backVideo":"dcce","image":"_3f7c","iconDiv":"_9097","icon":"cc0d","textBox":"d56e","button":"_4372"};